'use client';

import { useState, useEffect } from 'react';

export const useHash = () => {
	const [hash, setHash] = useState('');

	useEffect(() => {
		const onHashChange = () => {
			setHash(window.location.hash.replaceAll('#', ''));
		};

		onHashChange();
		window.addEventListener('hashchange', onHashChange);
		return () => window.removeEventListener('hashchange', onHashChange);
	}, []);

	return hash;
};
